/**
 * AM:fast — amfast.js
 * Handles: nav, cart modal, pack selection, qty, Mercado Pago, transfer, WhatsApp
 */

(function () {
  'use strict';

  /* ─── STATE ─── */
  const state = {
    currentPack: null,
    deliveryType: 'despacho',
    shippingCost: 2490,
  };

  /* ─── UTILS ─── */
  function fmt(n) {
    return '$' + Number(n).toLocaleString('es-CL');
  }

  function $(id) {
    return document.getElementById(id);
  }

  /* ─── NAV ─── */
  const hamburger = $('hamburger');
  const navDrawer = $('navDrawer');

  if (hamburger && navDrawer) {
    hamburger.addEventListener('click', function () {
      const isOpen = navDrawer.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', isOpen);
    });

    // Close drawer when a link is clicked
    navDrawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        navDrawer.classList.remove('open');
        hamburger.setAttribute('aria-expanded', false);
      });
    });
  }

  // Nav scroll shadow
  window.addEventListener('scroll', function () {
    const nav = document.getElementById('amf-nav');
    if (nav) {
      nav.classList.toggle('scrolled', window.scrollY > 20);
    }
  });

  /* ─── QTY CONTROLS ─── */
  window.changeQty = function (blockId, delta) {
    const el = $('qty_' + blockId);
    if (!el) return;
    const current = parseInt(el.textContent, 10) || 1;
    el.textContent = Math.max(1, current + delta);
  };

  /* ─── PACK MODAL ─── */
  window.openPackModal = function (blockId, packName, priceRaw, quantityRaw) {
    const qty = parseInt(($('qty_' + blockId) || {}).textContent || 1, 10);
    const flavorEl = $('flavor_' + blockId);
    const flavorText = flavorEl ? flavorEl.options[flavorEl.selectedIndex].text : 'Surtido';
    const flavorValue = flavorEl ? flavorEl.value : 'mix';

    state.currentPack = {
      name: packName,
      price: priceRaw,
      qty: qty,
      flavor: flavorText,
      flavorValue: flavorValue,
      totalPrice: priceRaw * qty,
    };

    // Pre-select flavor in modal
    const saborModal = $('saborModal');
    if (saborModal) saborModal.value = flavorValue;

    openModal();
  };

  window.openOferta = function (flavorName, price, units) {
    state.currentPack = {
      name: 'Caja Sabor Único 30u',
      price: price,
      qty: 1,
      flavor: flavorName,
      flavorValue: flavorName.toLowerCase().replace(' ', '_'),
      totalPrice: price,
    };
    openModal();
  };

  function openModal() {
    const modal = $('checkoutModal');
    if (modal) {
      modal.classList.add('open');
      modal.querySelector('.modal').focus();
    }
    AMFast.updateOrderSummary();
  }

  window.AMFast = {
    closeModal: function () {
      const modal = $('checkoutModal');
      if (modal) modal.classList.remove('open');
    },

    setDelivery: function (type, btn) {
      state.deliveryType = type;
      document.querySelectorAll('.toggle-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
      const addrFields = $('addressFields');
      if (addrFields) addrFields.style.display = type === 'despacho' ? 'block' : 'none';
      AMFast.updateOrderSummary();
    },

    updateShipping: function () {
      const region = $('region');
      if (!region) return;
      const val = region.value;
      state.shippingCost = val === 'v' ? 1990 : val === 'rm' ? 2490 : 3490;
      AMFast.updateOrderSummary();
    },

    updateOrderSummary: function () {
      const el = $('orderSummary');
      if (!el || !state.currentPack) return;
      const shipping = state.deliveryType === 'despacho' ? state.shippingCost : 0;
      const total = state.currentPack.totalPrice + shipping;

      el.innerHTML =
        '<div class="order-summary-row"><span>' + state.currentPack.name +
        ' × ' + state.currentPack.qty + '</span><span>' + fmt(state.currentPack.totalPrice) + '</span></div>' +
        '<div class="order-summary-row"><span>Sabor</span><span>' + state.currentPack.flavor + '</span></div>' +
        (state.deliveryType === 'despacho'
          ? '<div class="order-summary-row"><span>Despacho</span><span>' + fmt(state.shippingCost) + '</span></div>'
          : '<div class="order-summary-row"><span>Retiro en tienda</span><span style="color:#4caf50">GRATIS</span></div>') +
        '<div class="order-summary-row total"><span>Total</span><span>' + fmt(total) + '</span></div>';
    },

    goMercadoPago: function () {
      const nombre = ($('nombre') || {}).value;
      const tel = ($('telefono') || {}).value;
      if (!nombre || !tel) {
        alert('Por favor ingresa tu nombre y teléfono para continuar.');
        return;
      }
      // Use the Mercado Pago link from theme settings (injected via meta tag or data attribute)
      const mpLink = document.querySelector('meta[name="mp-link"]');
      if (mpLink && mpLink.content) {
        window.location.href = mpLink.content;
      } else {
        alert(
          '¡Gracias ' + nombre + '!\n\n' +
          'Te redirigiremos a Mercado Pago para completar tu compra de forma segura.\n\n' +
          '(Configura tu link de Mercado Pago en Shopify Admin > Online Store > Themes > Customize > Configuración > Contacto)'
        );
      }
    },

    showTransfer: function () {
      const transferInfo = $('transferInfo');
      if (transferInfo) {
        const isVisible = transferInfo.style.display !== 'none';
        transferInfo.style.display = isVisible ? 'none' : 'block';
      }
    },

    goWhatsApp: function () {
      const nombre = ($('nombre') || {}).value || '(sin nombre)';
      const saborEl = $('saborModal');
      const sabor = saborEl ? saborEl.options[saborEl.selectedIndex].text : 'Surtido';
      const pack = state.currentPack
        ? state.currentPack.name + ' × ' + state.currentPack.qty + ' (' + sabor + ')'
        : '(sin pack seleccionado)';
      const entrega = state.deliveryType === 'despacho' ? 'Despacho a domicilio' : 'Retiro en tienda';
      const direccion = ($('direccion') || {}).value || '';
      const ciudad = ($('ciudad') || {}).value || '';

      let msg = 'Hola AM:fast!\n📦 ' + pack + '\n👤 ' + nombre + '\n🚚 ' + entrega;
      if (direccion) msg += '\n📍 ' + direccion + ', ' + ciudad;

      // Get WA number from page (injected via data attribute on body or meta)
      const waMeta = document.querySelector('meta[name="wa-number"]');
      const waNumber = (waMeta && waMeta.content) ? waMeta.content : '56922234495';
      window.open('https://wa.me/' + waNumber + '?text=' + encodeURIComponent(msg), '_blank');
    },
  };

  /* ─── MODAL CLOSE ON OVERLAY CLICK ─── */
  const checkoutModal = $('checkoutModal');
  if (checkoutModal) {
    checkoutModal.addEventListener('click', function (e) {
      if (e.target === checkoutModal) AMFast.closeModal();
    });

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') AMFast.closeModal();
    });
  }

  /* ─── SMOOTH SCROLL for anchor links ─── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
